import * as React from 'react';
import { cn } from '@/lib/utils';

/* shadcn/ui Card, styled with the design reference's .card / .card-h / .card-b. */
export const Card = React.forwardRef<HTMLElement, React.HTMLAttributes<HTMLElement> & { as?: 'section' | 'div' | 'article' }>(
  ({ className, as: As = 'section', ...props }, ref) => <As ref={ref as never} className={cn('card', className)} {...props} />,
);
Card.displayName = 'Card';

export const CardHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => <div className={cn('card-h', className)} {...props} />;

/** The card's heading. `as` is the level a card sits at — h2 by default; a card inside a page section is an h3 (25 Oct 2026, Events). */
export const CardTitle = ({ className, as: Heading = 'h2', ...props }: React.HTMLAttributes<HTMLHeadingElement> & { as?: 'h2' | 'h3' | 'h4' }) => <Heading className={cn(className)} {...props} />;

export const CardContent = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => <div className={cn('card-b', className)} {...props} />;
